@if (canShow) {
  <button
    mat-menu-item
    (click)="onBulkIngest()"
    [disabled]="selectedProducts.length === 0"
    >
    <mat-icon>playlist_add</mat-icon>
    <span>Group Ingest</span>
  </button>
}
